import { ClientProxy } from '../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../base/models'
import { ICompany } from '../models/response/getOrderListResponseModel'

export class GetCompanyApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'homepage/company-list',
      requesterInfo,
    })
  }

  public async getCompanies(): Promise<ICompany[]> {
    return await this.getAsync<ICompany[]>()
  }
}
